// biome-ignore lint/style/noRestrictedImports: component usage
import { Root } from "@radix-ui/react-collapsible";
import { cx } from "@suse-o11y/class-variance";
import React from "react";

export type CollapsibleProps = React.ComponentPropsWithoutRef<typeof Root>;

export const Collapsible = React.forwardRef<HTMLDivElement, CollapsibleProps>((props, ref) => (
	<Root ref={ref} {...props} className={cx("group/collapsible", props.className)} />
));

if (import.meta.env.DEV) {
	Collapsible.displayName = "Collapsible";
}
